<script setup lang="tsx">
import { ref, watchEffect } from "vue";
import { mapState } from "../../context/context";

const props = withDefaults(
  defineProps<{
    color?: string;
  }>(),
  {}
);

const mappedState = mapState(["color.fontReverse"]);

const color = ref();

watchEffect(() => {
  color.value = props.color || mappedState["color.fontReverse"].value;
});
</script>

<template>
  <!-- 不设置 width="48" height="48" 自适应父元素 -->
  <!-- viewBox : x y width height , 可重设 viewBox 切除四周多余空白 -->
  <svg
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    preserveAspectRatio="none"
    fill="none"
    :style="{
      display: 'block',
      transformOrigin: 'center'
    }"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24 4C12.9587 4 4 12.9587 4 24C4 35.0413 12.9587 44 24 44C35.0413 44 44 35.0413 44 24C44 12.9587 35.0413 4 24 4ZM2 24C2 11.8542 11.8542 2 24 2C36.1458 2 46 11.8542 46 24C46 36.1458 36.1458 46 24 46C11.8542 46 2 36.1458 2 24Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M32.2771 17.2924L21.7545 28.6083L15.7129 22.7009C15.3228 22.3111 14.6826 22.3111 14.2926 22.7009C13.9025 23.0908 13.9025 23.7106 14.2926 24.1005L21.0444 30.7076C21.4345 31.0975 22.0746 31.0975 22.4647 30.7076L33.7074 18.6919C34.0975 18.3021 34.0975 17.6823 33.7074 17.2924C33.3174 16.9025 32.6772 16.9025 32.2771 17.2924Z"
      :fill="color"
    />
  </svg>
</template>
